import { render, staticRenderFns } from "./OutlierIndicatorText.vue?vue&type=template&id=2b1873ac&scoped=true&"
import script from "./OutlierIndicatorText.vue?vue&type=script&setup=true&lang=js&"
export * from "./OutlierIndicatorText.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./OutlierIndicatorText.vue?vue&type=style&index=0&id=2b1873ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1873ac",
  null
  
)

export default component.exports